module.exports = __webpack_public_path__ + "media/images/lb/666-db535a8a74aa5d235f30eef33c78e2b8.svg";